import { render, staticRenderFns } from "./AppStoreGridRowItem.vue?vue&type=template&id=349d4e52&scoped=true&"
import script from "./AppStoreGridRowItem.vue?vue&type=script&lang=js&"
export * from "./AppStoreGridRowItem.vue?vue&type=script&lang=js&"
import style0 from "./AppStoreGridRowItem.scss?vue&type=style&index=0&id=349d4e52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349d4e52",
  null
  
)

export default component.exports